<script setup lang="ts">
import { onMounted } from "vue";

const props = defineProps({
  googleTagManagerId: {
    type: String,
    default: process.env?.VUE_APP_GOOGLE_TAG_MANAGER_ID, // Customer Tracking
  },
});

const iframeHtml = `<iframe src="https://www.googletagmanager.com/ns.html?id=${props.googleTagManagerId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

onMounted(() => {
  if (document.getElementById("gtm-script")) return;

  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s);
    j.id = "gtm-script";
    const dl = l != "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    if (f && f.parentNode) {
      f.parentNode.insertBefore(j, f);
    } else {
      d.head.appendChild(j);
    }
  })(window, document, "script", "dataLayer", props.googleTagManagerId);
});
</script>

<template>
  <noscript v-html="iframeHtml"></noscript>
</template>
